<template>
  <div class="templates px-4 py-4 mb-4">
    <div class="display-1 font-weight-bold pb-4">
      Мои шаблоны выгрузки статистики
    </div>
    <v-select
      v-model="curTemplate"
      :items="$store.getters.templateList"
      @change="changeTemplate"
      item-text="name"
      return-object
      class="v-text-field--noBorder mb-3"
      hide-details
      dense
      solo
    >
      <template v-slot:selection="{ item }">
        <div class="ellipsis">{{ item.name }}</div>
      </template>
    </v-select>
    <div class="layout">
      <v-btn
        :to="{
          name: 'statisticsTemplates',
          params: { template: curTemplate }
        }"
        class="primary mb-0 ml-0 hidden-sm-and-down"
      >
        Перейти
      </v-btn>
      <download-xlsx-csv
        v-if="curTemplate"
        :param="curTemplate ? curTemplate.params : {}"
        :type="curTemplate ? curTemplate.params.type : ''"
        class="flex text-sm-right flex-column align-self-center"
      >
      </download-xlsx-csv>
    </div>
    <div class="font-weight-medium hidden-md-and-up">
      <div class="py-3">
        К сожалению, со смартфона вы не сможете перейти к описанию или
        реадктированию шаблона.
      </div>
      <div class="py-3">
        Не переживайте, вы можете сделать это на планшете или с компьютера.
      </div>
    </div>
  </div>
</template>
<script>
import DownloadXlsxCsv from "../common/DownloadXlsxCsv.vue";

export default {
  // Виджет на главной
  name: "Templates",

  components: {
    DownloadXlsxCsv
  },
  data: () => ({
    // текущий выбранный шаблон
    curTemplate: { params: { type: "" } }
  }),
  mounted() {
    this.$store.dispatch("templateListLoad").then(() => {
      this.changeTemplate(this.$store.getters.template);
    });
  },
  methods: {
    changeTemplate(item) {
      this.curTemplate = item;
    }
  }
};
</script>
